export default __webpack_public_path__ + "static/media/whitetail.123df567.png";